/**
 * Program Cards 1053 — KUK home "Featured Programmes".
 *
 * ONE ROW TYPE, TWO ROLES. A row with an empty "Parent programme" is a
 * PROGRAMME — it appears in the tab strip, the selectable list and the detail
 * card. A row that names one is a SPECIALISATION of the programme whose "Short
 * name" matches, and shows in that programme's badge count, its mobile chips and
 * the desktop specialisation grid. This is the convention Program Cards 1027
 * already uses; it needs no new column.
 */

export const PROGRAM_CARDS_1053_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Programmes and specialisations",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_title: "",
    meta_sub_title: "",
    meta_description: "",
    meta_duration: "",
    meta_image: "",
    meta_alt_image: "",
    meta_url: "",
    meta_brochure_url: "",
    meta_category: "",
    meta_parent_title: "",
    meta_icon: "",
    meta_priority: 1,
    meta_status: true,
  },

  PROGRAM_CARDS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "Featured Programmes",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Featured Programmes",
      defaultValue: "Featured Programmes",
    },
    {
      fieldName: "title_text_color",
      label: "Heading colour",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#031F44",
    },
    {
      fieldName: "gradient_color_1",
      label: "Heading rule colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      description: "The short accent bar under the heading.",
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "desktop_background_color",
      label: "Band background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "mobile_background_color",
      label: "Tab strip fill",
      value: "#F0F2F5",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#F0F2F5",
    },
    {
      fieldName: "card_hover_background_color",
      label: "Active tab fill",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "card_hover_text_color",
      label: "Active tab text",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_start_color",
      label: "Inactive tab text",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#031F44",
    },
    {
      fieldName: "card_background_color",
      label: "Programme card fill — unselected",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "gradient_color_2",
      label: "Programme card fill — selected",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "title_end_color",
      label: "Programme card text — unselected",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#031F44",
    },
    {
      fieldName: "gradient_color_3",
      label: "Programme card text — selected",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "salary_text_color",
      label: "Secondary body text",
      value: "#344054",
      valueType: "string",
      filedType: "COLOR",
      description: "The card sub-line and the detail card's description.",
      defaultValue: "#344054",
    },
    {
      fieldName: "key_skills_background_color",
      label: "Specialisation badge fill",
      value: "#FFD964",
      valueType: "string",
      filedType: "COLOR",
      description: 'The "N Specialisations" corner badge.',
      defaultValue: "#FFD964",
    },
    {
      fieldName: "key_skills_text_color",
      label: "Specialisation badge text",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#031F44",
    },
    {
      fieldName: "gradient_color_4",
      label: "Detail card fill",
      value: "#FEE2E2",
      valueType: "string",
      filedType: "COLOR",
      description: "Also the fill of the desktop specialisation cards.",
      defaultValue: "#FEE2E2",
    },
    {
      fieldName: "pre_title_color",
      label: "Accent text colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      description:
        "The detail card's eyebrow, the specialisation name and its Know-more link.",
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "key_skills_border_color",
      label: "Specialisation chip fill (mobile)",
      value: "#9F1C3333",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "#9F1C3333",
      defaultValue: "#9F1C3333",
    },
    {
      fieldName: "pre_title",
      label: '"Specialisations" label',
      value: "Specialisations",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Specialisations",
      description: "Used in the corner badge and above the mobile chips.",
      defaultValue: "Specialisations",
    },
    {
      fieldName: "description",
      label: "Specialisation grid heading",
      value: "Specializations",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Specializations",
      defaultValue: "Specializations",
    },
    {
      fieldName: "note",
      label: "Duration label",
      value: "Duration:",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Duration:",
      defaultValue: "Duration:",
    },
    {
      fieldName: "cta_text",
      label: "Know-more label",
      value: "Know more",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Know more",
      defaultValue: "Know more",
    },
    {
      fieldName: "cta_text_color",
      label: "Know-more text and border colour",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#031F44",
    },
    {
      fieldName: "load_more_text",
      label: "Brochure label",
      value: "Brochure",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Brochure",
      description: "Opens the lead popup with the selected row's brochure attached.",
      defaultValue: "Brochure",
    },
    {
      fieldName: "load_more_mobile_background_color",
      label: "Brochure button fill",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "load_more_desktop_text_color",
      label: "Brochure button text",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "load_more_desktop_icon",
      label: "Brochure button icon",
      value: "download",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "download",
      defaultValue: "download",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Short name",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Online MA",
      description: "Also the key a specialisation points at.",
      defaultValue: "",
    },
    {
      header: "Full name",
      fieldName: "meta_sub_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Master of Arts",
      defaultValue: "",
    },
    {
      header: "Parent programme",
      fieldName: "meta_parent_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Leave empty for a programme",
      description:
        "Set to a programme's Short name to make this row one of its specialisations.",
      defaultValue: "",
    },
    {
      header: "Level (tab)",
      fieldName: "meta_category",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Bachelors",
      description: "Tabs are the distinct levels, in row order. Programmes only.",
      defaultValue: "",
    },
    {
      header: "Description",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      defaultValue: "",
    },
    {
      header: "Duration",
      fieldName: "meta_duration",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "2 Years",
      defaultValue: "",
    },
    {
      header: "Thumbnail",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      defaultValue: "",
    },
    {
      header: "Thumbnail alt",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Page URL",
      fieldName: "meta_url",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/online-ma",
      defaultValue: "",
    },
    {
      header: "Brochure URL",
      fieldName: "meta_brochure_url",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "https://…/brochure.pdf",
      defaultValue: "",
    },
    {
      header: "Icon",
      fieldName: "meta_icon",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Empty uses the reference's graduation icon",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
